var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"flex-grow-1 mt-4",attrs:{"label":"Цвет фона","dense":"","outlined":"","hide-details":"auto","rules":[_vm.colorRule],"placeholder":"#FFFFFF"},on:{"input":_vm.validateAndNormalize},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('div',{style:({
        backgroundColor: _vm.isValidColor ? _vm.value : '#FFFFFF',
        width: '24px',
        height: '24px',
        borderRadius: '4px',
        border: '1px solid rgba(0, 0, 0, 0.24)',
        marginTop: '-2px'
      })})]},proxy:true}]),model:{value:(_vm.colorValue),callback:function ($$v) {_vm.colorValue=$$v},expression:"colorValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }